import * as React from "react";
import moment from "moment";
import { Button } from "reactstrap";
import CollaudoBot from "./test-dashboard-parts/Bot";
import { Alert, Col, Row, Card } from "reactstrap";
import { useParams, useHistory } from "react-router-dom";
import { resolveAddress } from "../../utils/position";
import PositionWaiting from "../../components/position/PositionWaiting";
import PositionView from "../../components/position/PositionView";
import PositionMap from "../../components/position/PositionMap";
import getCommandsCard from "../../components/position/getCommandsCard";
import { useAuth0 } from "../../auth/react-auth0-wrapper";
import PageLayout from "../../components/PageLayout";
import { getCollaudo, completeGisPhase } from "../../api/collaudo";
import { updateVehicle } from "../../api/vehicles";

export default function GisDashboard() {

    const google = window.google;
    const { collaudoId } = useParams();
    const [lastCommandResult, setResult] = React.useState();
    const [canCode, setCanCode] = React.useState();
    const [gapMapObj, setMapInstance] = React.useState();
    const [position, setPosition] = React.useState();
    const [address, setAddress] = React.useState("");
    const [device, setDevice] = React.useState();
    const [vehicle, setVehicle] = React.useState();
    const [collaudo, setCollaudo] = React.useState();
    const [gisDeviceStatus, setGisDeviceStatus] = React.useState("offline");
    const [gisDeviceInfo, setGisDeviceInfo] = React.useState();
    const { eventBus, gisApi, domains } = useAuth0();
    const { push } = useHistory()

    React.useEffect(() => {
        loadCollaudo();
    }, [])

    React.useEffect(() => {
        if (!device || !vehicle) return;
        const socketPromise = connectSocket();
        // Specify how to clean up after this effect:
        return async function cleanup() {
            const socket = await socketPromise;
            socket.close(1000, "cleanuppage");
        };
    }, [device, vehicle]);

    React.useEffect(() => {
        if (gapMapObj && position) {
            const newPoint = new google.maps.LatLng(
                position.latitude,
                position.longitude
            );
            gapMapObj.map.setCenter(newPoint);
            gapMapObj.map.panTo(newPoint);
        }
    });

    async function onCollaudoEnd(data) {

        const createdCollaudo = data.values.find(el => el.collaudo && el.isTestFinished)
        push(`/collaudo/docs/${createdCollaudo.collaudo._id}`)

    }

    async function onSaveCollaudo(tests) {
        const km = prompt("Inserire i Km del veicolo:", "");
        if (km) {
            await gisApi.updateAccumulators(gisDeviceInfo.id, km * 1000, 0);
            await updateVehicle({
                ...vehicle,
                km: km
            });
        }
        const meta = { ...collaudo.meta, tests, gisDeviceInfo };
        const collaudoUpdated = { ...collaudo, meta };
        const collaudonew = await completeGisPhase(collaudoUpdated);
        try {
            if (process.env.REMOVEDEVICEAFTERCOLLAUDO) {
                const deleted = await gisApi.deleteDevice(gisDeviceInfo.id);
                console.log(`device ${gisDeviceInfo.id} deletion result: ${deleted}`, gisDeviceInfo)
            }
        } catch {
            console.log('Failure deleting device from traccar')
        }
        return collaudonew;

    }

    async function loadCollaudo() {
        const collaudoRes = await getCollaudo(collaudoId);
        if (collaudoRes.status !== "inserito") {
            push(`/collaudo/docs/${collaudoRes._id}`)
        } else {
            setCollaudo(collaudoRes)
            setDevice(collaudoRes.meta.device)
            setVehicle(collaudoRes.meta.vehicle)
        }
    }

    function onMapReady(map) {
        setMapInstance(map);
    }

    async function updatePosition(position) {
        setPosition(position);

        try {
            const addr = await resolveAddress(position);
            setAddress(addr);
        } catch (error) {
            // unable to resolve address but we keep going
            console.log("Unable to resolve address but we keep going", error);
        }
    }

    async function connectSocket() {
        const gisDevice = await initData(device, vehicle);
        setGisDeviceInfo(gisDevice)

        if (!gisDevice) {
            eventBus.dispatchEvent(
                new CustomEvent("growl", {
                    detail: {
                        message: {
                            type: "error",
                            clear: true,
                            summary: "Errore Collaudo",
                            content: `Impossibile verificare i dati Gis del dispositivo ${device.imei}`
                        }
                    }
                })
            );
        }

        const socket = new WebSocket(`${domains.appSettings.gisWs}/api/socket`);

        socket.onclose = evt => {
            if (evt.reason !== "cleanuppage") {
                setTimeout(() => connectSocket(), 60 * 1000);
            }
        };

        socket.onmessage = event => {
            const data = JSON.parse(event.data);
            if (data.positions) {
                const devicePositions = data.positions.filter(
                    el => el.deviceId === gisDevice.id
                );
                const pos = devicePositions.length && devicePositions[0];
                if (pos) {
                    console.log("POSIZIONE", pos);
                    eventBus.dispatchEvent(
                        new CustomEvent("POSITION", {
                            detail: { position: pos }
                        })
                    );
                    updatePosition(pos);
                }
                if (pos && pos.attributes.result) {
                    setResult(pos.attributes.result);
                    console.log("POSIZIONE ED EVENTO", pos);
                    eventBus.dispatchEvent(
                        new CustomEvent("growl", {
                            detail: {
                                message: {
                                    type: "success",
                                    clear: true,
                                    summary: "Comando eseguito e confermata risposta da Gis",
                                    content: pos.attributes.result,
                                    clear: true
                                }
                            }
                        })
                    );
                    eventBus.dispatchEvent(
                        new CustomEvent("GISRESULT", {
                            detail: { position: pos }
                        })
                    );
                }
            }

            if (data.events) {
                const deviceEvents = data.events.filter(
                    el => el.deviceId === gisDevice.id
                );
                const evt = deviceEvents.length && deviceEvents[0];
                if (evt) {
                    console.log("EVENTO", evt);
                    if (evt.type == "commandResult" && evt.attributes.result.includes("Prog:")) {
                        const canData = evt.attributes.result.split(" ");
                        const canCodeData = canData[0].slice(5);
                        setCanCode(canCodeData);
                        console.log("CAN", `Codice linea CAN: ${canCodeData}`);
                    }

                    eventBus.dispatchEvent(
                        new CustomEvent("growl", {
                            detail: {
                                message: {
                                    type: "info",
                                    clear: true,
                                    summary: "Ricevuto evento da GIS",
                                    content: `${moment(evt.serverTime).format(
                                        "DD/MM/YYYY HH:mm:ss"
                                    )} ${evt.type}`
                                }
                            }
                        })
                    );
                }
            }

            if (data.devices) {
                const deviceInfo = data.devices.filter(el => el.id === gisDevice.id);
                const info = deviceInfo.length && deviceInfo[0];
                if (info) {
                    //console.log(info);
                    setGisDeviceStatus(info.status);
                }
            }
        };

        return socket;
    }

    async function initData(device, vehicle) {
        await gisApi.login();
        let gisDevice = await gisApi.getDevice(device.imei);

        if (!gisDevice) {
            gisDevice = await gisApi.createDevice(
                device.imei,
                device.number,
                `${vehicle.plate}`,
                "car"
            );
        }
        //RIMOSSO PERCHE BLOCCA LOAD INIZIALE!!
        // await gisApi.setDevice(device.number, 1800);
        return gisDevice;
    }

    function getPositionDetails(position) {
        if (!position) return null;
        return (
            <div>
                <Row>
                    <Col xs="12" md="6">
                        <PositionView
                            position={position}
                            address={address}
                            vehicle={vehicle}
                            lastCommandResult={lastCommandResult}
                            canCode={canCode}
                        />
                    </Col>
                    <Col xs="12" md="6">
                        <PositionMap
                            position={position}
                            onMapReady={onMapReady}
                            gisDeviceStatus={gisDeviceStatus}
                        />
                    </Col>
                </Row>
            </div>
        );
    }

    function getCommands(position) {
        if (!position) return null;
        return (
            <Row>
                <Col xs="12">
                    {getCommandsCard(device, position)}
                </Col>
                <Col xs="12" className="mt-2 mb-4">
                    <CollaudoBot
                        onCollaudoEnd={onCollaudoEnd}
                        onSaveCollaudo={onSaveCollaudo}
                        deviceId={position.deviceId}
                        collaudoId={collaudoId}
                        canCode={canCode}
                        online={gisDeviceStatus === "online"}
                        lastCommandResult={lastCommandResult}
                        noCanTest={collaudo.cancode=='' || collaudo.cancode==undefined}
                        canCodeId={collaudo.cancode}
                    />
                </Col>
            </Row>
        );
    }

    return (
        <PageLayout
            title={`Collaudo Dispositivo: ${collaudo ? "Targa " + collaudo.plate.toUpperCase() + " - CAN " + (collaudo.cancode || "n.d.") + " - IMEI " + collaudo.imei + " - Tel. dispositivo " + collaudo.attributes.number + " - Cliente " + collaudo.customer_name : null}`}
            optionalNav={{ link: "/collaudo/list", text: "Collaudi" }}
        >
            <Row>
                <Col xs="12" className="mt-1">
                    <PositionWaiting
                        display={position ? false : true}
                        //onRefresh={() => window.location.reload()}
                        onRefresh={async () => {
                            await gisApi.smsCommand(device.number, "p l getrecord");
                            eventBus.dispatchEvent(
                                new CustomEvent("growl", {
                                    detail: {
                                        message: {
                                            type: "success",
                                            clear: true,
                                            summary: "OPERAZIONE ESEGUITA",
                                            content: "Comando SVEGLIA inviato via SMS con successo."
                                        }
                                    }
                                })
                            );
                        }}
                    />
                    {getCommands(position)}
                    {getPositionDetails(position)}
                </Col>
            </Row>
        </PageLayout>
    );
}
